export const ONE_TRUST_FEATURE_FLAG = "oneTrust";
